import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import './info.less';

class Info extends Component {
  render() {
    return (
      <Tooltip placement={this.props.placement} title={this.props.tooltipContent}>
        <span className={'info'}>i</span>
      </Tooltip>
    );
  }
}

Info.propTypes = {
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placement: PropTypes.string
};

Info.defaultProps = {
  placement: 'right'
};

export default Info;
